import {
    createRestClient,
    processResponse,
    RestClient,
} from '@superbet-group/web.lib.rest';
import { IResponse } from '@superbet-group/web.lib.utilities';

import { defaultHttpTimeoutMs } from '@core/constants';
import { OfferEventDto } from '@core/mappers/offer/dtos/OfferEventDto';
import ResultsRequest from '@core/services/results/_private/models/ResultsRequest';

type PossibleError = { error?: boolean; notice?: string };

export default class RestService {
    private readonly restClient: RestClient;

    constructor(baseUrl: string) {
        this.restClient = createRestClient(baseUrl, defaultHttpTimeoutMs);
    }

    public getMatchResults<T extends OfferEventDto>(payload: MatchResultsPayload): Promise<IResponse<T[]> & PossibleError> {
        return processResponse(this.restClient.get('/events/by-date',
            {
                params: ResultsRequest.createMatchResultsRequest(
                    payload.startDate,
                    payload.endDate,
                    payload.sportId,
                    payload.tournamentIds,
                ),
            },
        ));
    }

    public getMatchResultDetails<T extends OfferEventDto[]>(matchId: number, oddsResults = true): Promise<IResponse<T> & PossibleError> {
        return processResponse(this.restClient.get(`/events/${matchId}`,
            {
                params: ResultsRequest.createMatchResultDetailsRequest(oddsResults),
            },
        ));
    }
}

type MatchResultsPayload = {
    startDate: Date;
    endDate: Date;
    sportId?: number;
    tournamentIds?: number[];
};
